import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function TermsConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 pt-32 pb-12 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
        
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6 text-gray-700 leading-relaxed">
          <p>
            By accessing or using this website, you agree to comply with and be bound by the following terms:
          </p>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. General</h2>
            <p>
              By using this platform, you confirm that you have read, understood, and agreed to these Terms. If you do not agree, please do not use this website.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Payments</h2>
            <p>
              All payments must be made carefully and after verifying details. Once a payment is made, it cannot be canceled or reversed. We are not responsible for incorrect payments made by users. Users must ensure accuracy before making any transaction.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. No Refund Policy</h2>
            <p>
              All payments are final and non-refundable under any circumstances. No refunds will be issued for change of mind, misunderstanding, or user error.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. User Responsibility</h2>
            <p>
              Users are responsible for providing accurate and complete information. Any loss due to incorrect or false information is the user’s responsibility.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Limitation of Liability</h2>
            <p>
              We are not liable for any direct or indirect loss, damages, or issues arising from use of this platform. We do not guarantee uninterrupted or error-free service.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Prohibited Use</h2>
            <p>
              Users agree not to: Use the website for illegal purposes, Attempt to harm, hack, or misuse the platform, Violate any applicable laws.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Changes to Terms</h2>
            <p>
              We may update these Terms at any time without prior notice. Continued use of the website means acceptance of updated terms.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Contact</h2>
            <p className="mb-4">
              Email: sales@ecomtamil.in
            </p>
            <div>
              <p className="font-semibold text-gray-900">Building No 5, Bajanai Koil Street</p>
              <p>Hastinapuram, Chennai</p>
              <p>Chengalpattu, Tamil Nadu</p>
              <p>PIN Code: 600064</p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
